var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 426,
    viewBox: "0 0 280 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.792 1.03867C58.8515 11.6357 14.4695 54.3077 2.79354 111.605C-9.46146 171.738 18.9465 259.145 81.2845 353.113C95.7555 374.927 108.02 391.798 122.353 409.613C134.73 424.995 135.672 425.821 140.384 425.43C143.766 425.149 145.001 424.194 151.137 417.113C160.936 405.806 182.501 376.821 195.618 357.327C241.481 289.172 268.406 227.586 277.466 170.113C280.095 153.443 279.857 125.293 276.975 111.925C264.878 55.8027 224.159 14.6467 168.292 2.07667C158.547 -0.116331 127.735 -0.749333 117.792 1.03867ZM151.598 64.6507C181.125 69.4427 205.26 91.4027 212.953 120.477C215.725 130.956 215.725 147.27 212.953 157.749C205.972 184.13 185.159 205.081 158.792 212.269C149.78 214.725 129.72 214.715 120.852 212.25C99.1995 206.231 81.9145 191.936 72.3175 172.113C66.9035 160.93 64.7915 151.589 64.7915 138.826C64.7915 92.8027 106.334 57.3057 151.598 64.6507Z",
    fill: "url(#paint0_linear_283_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_12",
    x1: 134,
    y1: 86,
    x2: 169,
    y2: 325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.5f0621adfe66c1d4b67f18a992fed746.svg";
export { ForwardRef as ReactComponent };